export const WEEK = 604800.0 // 7 * 24 * 60 * 60
export const USECS = 1000000.0
